import { startOfDay } from 'date-fns';

import { CalendarEvent } from 'types/interviewSlots';

/**
 * Month view only needs one marker per cell. For each calendar day, keep the slot
 * that starts earliest that day; ignore the rest for that day.
 */
export const collapseEventsToOnePerDay = (
  events: CalendarEvent[]
): CalendarEvent[] => {
  const earliestEventPerCalendarDay = new Map<number, CalendarEvent>();
  const sortedEarliestFirst = [...events].sort(
    (first, second) => first.start.getTime() - second.start.getTime()
  );

  for (const calendarEvent of sortedEarliestFirst) {
    const dayStartTimestamp = startOfDay(calendarEvent.start).getTime();

    const dayAlreadyHasEvent = earliestEventPerCalendarDay.has(dayStartTimestamp);
    if (dayAlreadyHasEvent) {
      continue;
    }
    earliestEventPerCalendarDay.set(dayStartTimestamp, calendarEvent);
  }

  return [...earliestEventPerCalendarDay.values()];
};
